module.exports = __webpack_public_path__ + "img/marker.5e71e455.svg";